document.querySelectorAll("a[href]").forEach((link) => {
  const href = link.getAttribute("href");
  if (!href) return;

  const isExternal =
    href.startsWith("http") && !href.includes(location.hostname);
  const isPDF = href.toLowerCase().endsWith(".pdf");

  /* External links */
  if (isExternal) {
    link.classList.add("external-link");
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener");

    const sr = document.createElement("span");
    sr.className = "screen-reader-text";
    sr.textContent = " (opens in a new window)";
    link.appendChild(sr);
  }

  /* PDF downloads */
  if (isPDF) {
    link.classList.add("pdf-link");

    const sr = document.createElement("span");
    sr.className = "screen-reader-text";
    sr.textContent = " (PDF download)";
    link.appendChild(sr);
  }
});
